import React, { ReactNode } from 'react';
import { Box, Container, Hidden, Link, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Gap, Spacer } from 'components';
import beachImg from 'images/beach.jpg';

const ScrollContainer = styled(Box)`
  overflow: auto;
  position: relative;
  margin-top: 64px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 64px);
`;

const StyledContent = styled(Container)`
  padding: ${p => p.theme.spacing(3, 3)};
  background: ${p => p.theme.palette.background.paper};
  border-radius: ${p => p.theme.spacing(3)}px;
  box-shadow: ${p => p.theme.shadows[1]};
  flex: 0;
`;

const Footer = styled(Typography)`
  width: 100%;
  padding: ${p => p.theme.spacing(2, 0)};
  background-color: ${p => p.theme.palette.background.default};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;

const FooterSeparator = styled.span`
  color: ${p => p.theme.palette.text.secondary};
  margin: ${p => p.theme.spacing(0, 1.25)};
`;

const FooterLink = styled(Link)`
  color: inherit;
  text-underline-offset: 0.15em;
`;

const BgHeader = styled(Box)`
  display: block;
  width: 100%;
  height: 300px;
  background-size: cover;
  background-image: url("${beachImg}");
  overflow: hidden;
  background-position: center;
  position: absolute;
  z-index: -1;
`;

interface Props {
  children: ReactNode;
  ignoreContainer?: boolean;
  noHeader?: boolean;
}

export function Page({ children, ignoreContainer, noHeader }: Props) {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const MainContainer = ignoreContainer ? Box : ScrollContainer;
  const PageContainer = ignoreContainer ? Box : StyledContent;
  return (
    <MainContainer>
      {!ignoreContainer && (
        <Hidden mdDown>
          {!noHeader && <BgHeader />}
          <Gap size={4} />
        </Hidden>
      )}
      <PageContainer>{children ?? <></>}</PageContainer>
      <Gap size={4} />
      <Spacer />
      <Footer variant="caption" align="center">
        <Typography variant="caption">{`© ${year} GoemansTech`}</Typography>
        <FooterSeparator aria-hidden="true">•</FooterSeparator>
        <FooterLink
          variant="caption"
          href="https://blog.spothr.net"
          target="_blank"
          rel="noopener noreferrer"
        >
          Spot HR Blog
        </FooterLink>
        <FooterSeparator aria-hidden="true">•</FooterSeparator>
        <FooterLink variant="caption" href="/mcp-setup">
          {t('footerMcpSetup')}
        </FooterLink>
      </Footer>
    </MainContainer>
  );
}
